import { Link } from "react-router-dom";

function NotFound() {
  const idioma = localStorage.getItem("ubicacion");

  const onClickAr = () => {
    if (idioma === "ar") return;
    else localStorage.setItem("ubicacion", "ar");
  };

  const onClickUy = () => {
    if (idioma === "uy") return;
    else localStorage.setItem("ubicacion", "uy");
  };

  return (
    <div className="min-h-[80dvh] mt-12 flex items-center justify-center bg-gray-50 px-6">
      <div className="text-center">
        <h1 className="text-7xl md:text-9xl font-bold text-gray-800">404</h1>

        <h2 className="mt-4 text-2xl md:text-5xl font-semibold text-gray-700">
          Página no encontrada
        </h2>

        <p className="mt-3 text-gray-500 text-2xl md:text-3xl">
          La página que intentaste visitar no existe o fue movida.
        </p>
        <div className="flex flex-row justify-center items-center gap-20 mt-10">
          <div className=" flex flex-col md:flex-col gap-4 justify-center">
            <Link
              to="/ar/"
              onClick={onClickAr}
              className="inline-block mt-4 border border-black px-6 py-3 hover:bg-tono1 hover:text-white transition"
            >
              Argentina
            </Link>
          </div>
          <div className="flex flex-row justify-center gap-6">
            <Link
              to="/uy/"
              onClick={onClickUy}
              className="inline-block mt-4 border border-black px-6 py-3 hover:bg-tono1 hover:text-white transition"
            >
              Uruguay
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
